import Button from "@components/Button";
import React, { Component } from "react";
import { defineMessages, injectIntl } from "react-intl";
import styles from "./ExpandableCell.module.scss";
import { ExpandableCellProps, ExpandableCellState } from "./ExpandableCellModel";

const expandableCellLabels = defineMessages({
  hideDescription: {
    id: "ExpandableCell.hideDescr",
    defaultMessage: "Hide description",
  },
  expandDescription: {
    id: "ExpandableCell.expandDescr",
    defaultMessage: "Expand description",
  },
});

class ExpandableCell extends Component<ExpandableCellProps, ExpandableCellState> {
  state = { isExpanded: false };

  onExpand = () => this.setState({ isExpanded: !this.state.isExpanded });
  createTags = (tags: string[]) => tags.map((tag) => `#${tag}`).join(" ");
  render() {
    const {
      data: { name, description, tags },
      intl: { formatMessage },
    } = this.props;
    const { isExpanded } = this.state;
    return (
      <div className={styles.ExpandableCellContainer}>
        <h3 id="expandCell_name" className={styles.ExpandableCellTitle}>
          {name}
        </h3>
        {description && (
          <Button
            onClick={this.onExpand}
            ghost={true}
            className={styles.ExpandableCellToggle}
            style={{ width: "auto" }}
          >
            <span>
              {isExpanded
                ? formatMessage(expandableCellLabels.hideDescription)
                : formatMessage(expandableCellLabels.expandDescription)}
            </span>
          </Button>
        )}
        {isExpanded && <div id="expandCell_description">{description}</div>}
        {tags && (
          <p id="expandCell_tags" className={styles.ExpandableCellTags}>
            {this.createTags(tags as string[])}
          </p>
        )}
      </div>
    );
  }
}

export default injectIntl(ExpandableCell);
